

export class ExpenseDto implements IExpenseDto {
    id!: number;
    projectId!: number | undefined;
    projectName!: string | undefined;
    expenseCategoryId!: number;
    expenseCategoryName!: string | undefined;
    accountId!: number;
    accountName!: string | undefined;
    amount!: number;
    transactionDate!: Date;
    description!: string | undefined;

    constructor(data?: IExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.expenseCategoryName = _data["expenseCategoryName"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.amount = _data["amount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["expenseCategoryName"] = this.expenseCategoryName;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["amount"] = this.amount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data; 
    }
}

export interface IExpenseDto {
    id: number;
    projectId: number | undefined;
    projectName: string | undefined;
    expenseCategoryId: number;
    expenseCategoryName: string | undefined;
    accountId: number;
    accountName: string | undefined;
    amount: number;
    transactionDate: Date;
    description: string | undefined;
}

